import { render, staticRenderFns } from "./AIAnswerMobile.vue?vue&type=template&id=42237695&scoped=true"
import script from "./AIAnswerMobile.vue?vue&type=script&lang=js"
export * from "./AIAnswerMobile.vue?vue&type=script&lang=js"
import style0 from "./AIAnswerMobile.vue?vue&type=style&index=0&id=42237695&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42237695",
  null
  
)

export default component.exports